// A regex rather than Intl.Segmenter: Vite's default build target still
// includes Firefox releases that ship without the segmenter.
const SENTENCE_END_PATTERN = /[.!?](?=\s|$)/u;

export function firstSentence(text: string): string {
  const trimmed = text.trim();
  const end = trimmed.search(SENTENCE_END_PATTERN);
  return end === -1 ? trimmed : trimmed.slice(0, end + 1);
}
